query groupsFilter($scenarioId: ID!, $filterId: ID!, $pagination: PaginationInput) {
  filter(scenarioId: $scenarioId) {
    groups(filterId: $filterId, pagination: $pagination) {
      items {
        id
        code
        label
        name
        capacity
        clientCode
        visibleForEnrollment
        term {
          id
          code
        }
        labels {
          id
          code
          name
          category {
            id
            code
            name
          }
        }
        course {
          code
          name
          curriculum {
            id
            name
            program {
              id
              code
              campus {
                id
                code
                name
                __typename
              }
            }
          }
        }
        links {
          id
          vacancies
          code
          bundle {
            id
            code
            label
            name
            capacity
          }
        }
        enrollmentStats {
          id
          enrollmentsCount
          waitingListsCount
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        page
        size
        total
      }
    }
  }
}
